import { makeStyles } from "tss-react/mui"

export const useStyles = makeStyles()(() => ({
  searchContainer: {
    width: "250px"
  }
}))
